export const VALID_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif,image/*'];
export const VALID_IMAGE_ACCEPT_TYPES = VALID_IMAGE_TYPES.join(',');
export const DEFAULT_MAX_IMAGE_SIZE = 5000000;
export const DEFAULT_LEAD_EXPIRATION_HOURS = 48;
